import script from "./UnsplashSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./UnsplashSearch.vue?vue&type=script&setup=true&lang=js"

import "./UnsplashSearch.vue?vue&type=style&index=0&id=137034d5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-137034d5"]])

export default __exports__